import { FormControl, ValidatorFn } from "@angular/forms";

export function CheckLastInserted(lastInserted: string, maxRead: string): ValidatorFn {
    return (control: FormControl): { [key: string]: boolean } => {
        const convertedLastInserted = Number(lastInserted);
        const convertedMaxRead = maxRead !== null ? Number(maxRead) : maxRead;
        /* Quando o contador deu a volta */
        const meterNotWentBack = convertedMaxRead > convertedLastInserted || convertedMaxRead === null;

        if (!control.value) {
            return null;
        }
        if (control.value < convertedLastInserted && meterNotWentBack) {
            return { invalidLastInserted: true };
        }
    };
}
